module.exports = __webpack_public_path__ + "static/media/tom160px.2d7feb78.jpg";